var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12", md: "5" } },
        [
          _c(
            "w-card",
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("title-stock")))]),
              _c(
                "w-card-content",
                [
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        [
                          _c("w-checkbox", {
                            attrs: {
                              space: _vm.$wf.isSmDown,
                              label: _vm.$ct("computeStock"),
                            },
                            model: {
                              value: _vm.product.ComputeStock,
                              callback: function ($$v) {
                                _vm.$set(_vm.product, "ComputeStock", $$v)
                              },
                              expression: "product.ComputeStock",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        [
                          _c("w-checkbox", {
                            attrs: {
                              space: _vm.$wf.isSmDown,
                              label: _vm.$ct("min-stock-enabled"),
                            },
                            model: {
                              value: _vm.productStock.MinStock1Enabled,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.productStock,
                                  "MinStock1Enabled",
                                  $$v
                                )
                              },
                              expression: "productStock.MinStock1Enabled",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        [
                          _vm.productStock
                            ? _c("w-input-number", {
                                attrs: {
                                  disabled: !_vm.productStock.MinStock1Enabled,
                                  label: _vm.$ct("labels.min-stock"),
                                },
                                model: {
                                  value: _vm.productStock.MinStockQty1,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.productStock,
                                      "MinStockQty1",
                                      $$v
                                    )
                                  },
                                  expression: "productStock.MinStockQty1",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.hasSizeModule
                    ? _c(
                        "w-row",
                        [
                          _c(
                            "w-col",
                            [
                              _c("w-select", {
                                attrs: {
                                  items: _vm.sizeTableItems,
                                  fancy: "",
                                  label: _vm.$ct("size-table"),
                                },
                                model: {
                                  value: _vm.product.SizeTableID,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.product, "SizeTableID", $$v)
                                  },
                                  expression: "product.SizeTableID",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm.hasSizeModule &&
          _vm.product.SizeTableID &&
          _vm.product.SizeBarcodes.length
            ? _c(
                "w-card",
                { staticClass: "mt" },
                [
                  _c("w-card-title", [
                    _vm._v(_vm._s(_vm.$ct("size-barcodes-title"))),
                  ]),
                  _c(
                    "w-card-content",
                    _vm._l(_vm.product.SizeBarcodes, function (barcode) {
                      return _c(
                        "w-row",
                        {
                          key: barcode.SizeTableEntryID,
                          attrs: { center: "" },
                        },
                        [
                          _c("w-col", { attrs: { xs: "3" } }, [
                            _vm._v(
                              _vm._s(_vm.entryName(barcode.SizeTableEntryID))
                            ),
                          ]),
                          _c(
                            "w-col",
                            { attrs: { xs: "9" } },
                            [
                              _c("w-input", {
                                attrs: {
                                  fancy: "",
                                  label: _vm.$ct("barcode"),
                                  icon: barcode.Barcode ? undefined : "magic",
                                  "icon-tooltip": _vm.$ct("generate-barcode"),
                                },
                                on: {
                                  "icon-click": function ($event) {
                                    return _vm.generateForRow(barcode)
                                  },
                                },
                                model: {
                                  value: barcode.Barcode,
                                  callback: function ($$v) {
                                    _vm.$set(barcode, "Barcode", $$v)
                                  },
                                  expression: "barcode.Barcode",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.product.ComputeStock && _vm.advancedStockHandling
            ? _c(
                "w-card",
                { staticClass: "mt" },
                [
                  _c("w-card-title", [
                    _vm._v(_vm._s(_vm.$ct("writeOffTitle"))),
                  ]),
                  _c(
                    "w-list",
                    [
                      _vm._l(_vm.product.WriteOffProducts, function (item, i) {
                        return _c(
                          "w-list-item",
                          { key: i },
                          [
                            _c(
                              "w-list-item-text",
                              [
                                _vm._v(" " + _vm._s(item.Amount) + " "),
                                item.WriteOffProduct
                                  ? [
                                      _vm._v(
                                        "x " + _vm._s(item.WriteOffProduct.Sku)
                                      ),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            ),
                            _c(
                              "w-list-item-action",
                              [
                                _c(
                                  "w-button",
                                  {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip",
                                        value: _vm.$ct("common.edit"),
                                        expression: "$ct('common.edit')",
                                      },
                                    ],
                                    on: {
                                      click: function ($event) {
                                        return _vm.editEntry(item)
                                      },
                                    },
                                  },
                                  [_c("w-fa", { attrs: { icon: "pen" } })],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "w-list-item-action",
                              [
                                _c(
                                  "w-button",
                                  {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip",
                                        value: _vm.$ct("common.delete"),
                                        expression: "$ct('common.delete')",
                                      },
                                    ],
                                    staticClass: "danger",
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeEntry(i)
                                      },
                                    },
                                  },
                                  [_c("w-fa", { attrs: { icon: "trash" } })],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                      _c(
                        "w-list-item",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.add()
                            },
                          },
                        },
                        [
                          _c("w-list-item-text", [
                            _c(
                              "span",
                              [
                                _c("w-fa", { attrs: { icon: "plus" } }),
                                _vm._v(
                                  " " + _vm._s(_vm.$t("common.add")) + " "
                                ),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "w-modal",
                        { attrs: { value: _vm.toEditWriteOff != null } },
                        [
                          _vm.toEditWriteOff
                            ? _c("app-products-product-edit-write-off", {
                                attrs: {
                                  "write-off-product": _vm.toEditWriteOff,
                                },
                                on: {
                                  confirm: function ($event) {
                                    return _vm.onConfirmAdd($event)
                                  },
                                  close: function ($event) {
                                    return _vm.closeModal()
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12", md: "7" } },
        [
          _vm.product.StockID
            ? _c("app-actual-stock", {
                attrs: { id: _vm.product.StockID, product: _vm.product },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }